import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import { createRoot } from 'react-dom/client';
import App from './App';

dayjs.extend(utc);
dayjs.extend(isBetween);
createRoot(document.getElementById('root')!).render(<App />);
